import {Collection} from 'backbone';

class Items extends Collection.extend({}) {}

export default Items;
